export const UIButton = ({
  children,
  onClick,
  disabled = false,
  type = "button",
  variant = "primary",
  className = "",
}) => {
  const baseClasses =
    "w-full px-4 py-2 text-sm font-medium rounded-lg focus:outline-none focus:ring-4 transition-colors";
  const variants = {
    primary:
      "text-white bg-green-600 hover:bg-green-700 focus:ring-green-300 disabled:bg-gray-400",
    outline:
      "text-green-600 bg-white border border-green-600 hover:bg-green-50 focus:ring-green-300",
    ghost:
      "text-green-600 bg-transparent hover:bg-green-50 focus:ring-green-300",
  };
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variants[variant]} ${className}`}
    >
      {children}
    </button>
  );
};
